// extracted by mini-css-extract-plugin
module.exports = {"container":"Skeleton_container__2Ch5k","rounded":"Skeleton_rounded__2eItx","circle":"Skeleton_circle__36qP6","load-skeleton":"Skeleton_load-skeleton___IFWE"};